import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpHeaders} from '@angular/common/http';
import {v4 as uuidV4} from 'uuid';
import {DcpApiService} from '@dcp/configurator';

export const cacheUpdateUrls = {
  reloadUserCache: 'user',
  reloadCustomerCache: 'customer'
};

@Injectable({
  providedIn: 'root'
})
export class CacheUpdateService {

  constructor(
    private apiService: DcpApiService,
  ) {
  }

  updateTransactionsCache(userId: string = '', cacheUpdateType: string): Observable<any> {
    const headersCacheUpdate = {
      'Content-Type': 'application/json; charset=utf-8',
      'ce-specversion': '1.0',
      'ce-type': cacheUpdateType === cacheUpdateUrls.reloadUserCache ? 'sapcrm.user.updated.v1' : 'sapcrm.account.cachereload.v1',
      'ce-eventtypeversion': 'v1',
      'ce-id': uuidV4(),
      'ce-source': 'sapcrm',
    };
    const options = {headers: new HttpHeaders(headersCacheUpdate), body: {UserId: userId}};
    const namespace = cacheUpdateType === cacheUpdateUrls.reloadUserCache ? 'reloadUserCache' : 'reloadCustomerCache';
    return this.apiService.callKyma(namespace, '', {}, options, 'POST');
  }
}
